import { handleActions } from 'redux-actions';
import { SET_RECIPIENTS_ORDER_BY } from './actions';
import { RecipientsOrderBy } from './types';
import { RecipientsTable } from '../../interfaces/recipientsTable';

type ActionType = {
  type: string;
  recipientsOrderBy: RecipientsOrderBy;
  payload: any; // unused -- added for TS
};

const initialState: RecipientsTable = {
  recipientsOrderBy: {
    orderDir: 'asc',
    keyName: 'name',
  },
};

export const setRecipientsOrderBy = (
  state: RecipientsTable,
  { recipientsOrderBy }: ActionType,
) => {
  return {
    ...state,
    recipientsOrderBy,
  };
};

const mappedReducers = {
  [SET_RECIPIENTS_ORDER_BY]: setRecipientsOrderBy,
};

const recipientsTableState = handleActions(mappedReducers, initialState);

export default recipientsTableState;
